import { IconFn, IconSvg } from "../createIcon";

export const ArrowDownIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 48, height: 48 }} {...props}>
    <g clipPath="url(#clip0_1676_16542)">
      <path d="M6.85714 10L24 27.1429L41.1429 10L48 13.4286L24 37.4286L0 13.4286L6.85714 10Z" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_1676_16542">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
